module.exports = __webpack_public_path__ + "assets/img/DS-bathroom common (1).40794594.jpg";